// Country name to code mapping
export const COUNTRY_NAME_TO_CODE = {
  'India': 'IN', 'United States': 'US', 'United Kingdom': 'GB', 'China': 'CN',
  'Japan': 'JP', 'Germany': 'DE', 'Brazil': 'BR', 'Indonesia': 'ID',
  'Russia': 'RU', 'Mexico': 'MX', 'Vietnam': 'VN', 'South Korea': 'KR',
  'France': 'FR', 'Canada': 'CA', 'Australia': 'AU', 'Spain': 'ES',
  'Italy': 'IT', 'Philippines': 'PH', 'Thailand': 'TH', 'Saudi Arabia': 'SA',
  'UAE': 'AE', 'Poland': 'PL', 'Argentina': 'AR', 'Egypt': 'EG',
  'Netherlands': 'NL', 'Sweden': 'SE', 'Belgium': 'BE', 'Singapore': 'SG'
};

// Country code to name mapping
export const COUNTRY_CODE_TO_NAME = {
  'IN': 'India', 'US': 'United States', 'GB': 'United Kingdom', 'CN': 'China',
  'JP': 'Japan', 'DE': 'Germany', 'BR': 'Brazil', 'ID': 'Indonesia',
  'RU': 'Russia', 'MX': 'Mexico', 'VN': 'Vietnam', 'KR': 'South Korea',
  'FR': 'France', 'CA': 'Canada', 'AU': 'Australia', 'ES': 'Spain',
  'IT': 'Italy', 'PH': 'Philippines', 'TH': 'Thailand', 'SA': 'Saudi Arabia',
  'AE': 'UAE', 'PL': 'Poland', 'AR': 'Argentina', 'EG': 'Egypt',
  'NL': 'Netherlands', 'SE': 'Sweden', 'BE': 'Belgium', 'SG': 'Singapore'
};

/**
 * Convert country name to code
 * Handles both full names (e.g., "UAE") and codes (e.g., "AE")
 * @param {string} countryValue - Full name (e.g., "UAE") or code (e.g., "AE")
 * @returns {string} - Country code (e.g., "AE")
 */
export const countryNameToCode = (countryValue) => {
  if (!countryValue) return 'IN'; // Default to India
  
  // If it's already a 2-letter code (uppercase), return as-is
  if (countryValue.length === 2 && countryValue === countryValue.toUpperCase()) {
    return countryValue;
  }
  
  // If it's a full name, convert to code
  return COUNTRY_NAME_TO_CODE[countryValue] || countryValue;
};

/**
 * Convert country code to name
 * @param {string} countryCode - Country code (e.g., "AE")
 * @returns {string} - Full name (e.g., "UAE")
 */
export const countryCodeToName = (countryCode) => {
  if (!countryCode) return 'India'; // Default to India
  
  return COUNTRY_CODE_TO_NAME[countryCode] || countryCode;
};


